// Comité de Crédito › Historial: la entrada que dejó la migración de cartera por Excel.
export function MarcaMigracionComite({ h, i }) {
  if (h?.origen !== "migracion_cartera") return null;
  return (
    <span data-testid={`comite-marca-migracion-${i}`}
      className="rounded bg-indigo-600 px-1.5 py-0.5 text-[10px] font-medium text-white">
      {h.marca || "Autorizado por migración"}{h.lote_id ? ` · lote ${h.lote_id}` : ""}
    </span>
  );
}
